import { arrayContains } from 'utils';
import { SEND_CANCELLATION_REQUEST } from 'redux/actions';

export const hasCancellationRequest = (state) => arrayContains(state.entities.users.openRequests, [SEND_CANCELLATION_REQUEST]);
